<template>
  <div class="welcome-card">
    <div class="welcome-card__item">
      <img src="../../assets/svg/money-envelope.svg"/>
      <p class="welcome-card__item-text">Samla din information</p>
    </div>

    <div class="welcome-card__item">
      <img src="../../assets/svg/security.svg"/>
      <p class="welcome-card__item-text">Säker hantering av personuppgifter</p>
    </div>

    <div class="welcome-card__item">
      <img src="../../assets/svg/chart-upwards.svg"/>
      <p class="welcome-card__item-text">Ta tempen på din pension!</p>
    </div>

    <div class="welcome-card__item">
      <img src="../../assets/svg/home.svg"/>
      <p class="welcome-card__item-text">Helt oberoende</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WelcomeCard',
  props: [ ],
}
</script>


<style lang="scss" scoped>
.welcome-card {
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 20px;
  width: 90%;
  margin: -30px auto 60px auto;
  max-width: $maxWidth;

  &__item {
    height: 240px;
    padding: 20px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    background-color: #F8FCF6;
    border: 1px solid #E9ECE7;
    border-radius: 6px;

    &-text {
      font-size: 20px;
      font-weight: bold;
      color: #0F7354;
      margin-top: 25px;
    }
  }

  @include breakpoints(medium) {
    grid-template-columns: 1fr 1fr;
    width: 80%;
  }

  @include breakpoints(large) {
    grid-template-columns: 1fr 1fr 1fr 1fr;
  }
}
</style>